/* All amounts are supplied by the merchant. Missing prices never become €0 quotes. */
(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.TMQuotePricing = api;
})(typeof window === 'undefined' ? globalThis : window, function () {
  'use strict';
  function cents(value) {
    const text = String(value ?? '').trim().replace(',', '.');
    if (!/^\d{1,7}(?:\.\d{1,2})?$/.test(text)) return null;
    const [whole, fraction = ''] = text.split('.');
    return Number(whole) * 100 + Number(fraction.padEnd(2, '0'));
  }
  function calculate(product, state) {
    const quantity = Number(state.quantity), min = Number(product.minimum ?? 1);
    if (!Number.isSafeInteger(min) || min < 1 || min > 100000) return { status: 'configuration' };
    if (!Number.isSafeInteger(quantity) || quantity < min || quantity > 100000) return { status: 'quantity', minimum: min };
    if (!['normal', 'oversize', 'box'].includes(state.fit) || !product.weights[state.weight]) return { status: 'selection' };
    if (!['yes', 'no', 'help'].includes(state.design)) return { status: 'design' };
    if (state.colour === 'custom' && !String(state.pms || '').trim()) return { status: 'pms' };
    if (product.pricing !== true) return { status: 'quote' };
    const base = cents(product.weights[state.weight].price);
    const fit = cents(product.fitFees[state.fit]);
    const colour = state.colour === 'custom' ? cents(product.pmsFee) : 0;
    const design = state.design === 'help' ? cents(product.designFee) : 0;
    if (base === null || base <= 0 || [fit, colour, design].some(x => x === null)) return { status: 'quote' };
    const tiers = product.discounts || [];
    if (tiers.some(t => !Number.isInteger(Number(t.quantity)) || Number(t.quantity) < 1 || !Number.isFinite(Number(t.percent)) || Number(t.percent) < 0 || Number(t.percent) > 80)) return { status: 'configuration' };
    const discount = Math.max(0, ...tiers.filter(t => quantity >= Number(t.quantity)).map(t => Number(t.percent)));
    const unit = Math.round((base + fit + colour) * (100 - discount) / 100);
    return { status: 'priced', quantity, unit, design, discount, total: unit * quantity + design };
  }
  return { cents, calculate };
});
